// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.error-list[data-v-3ae6c013] {\n    list-style-type: none;\n}\n", ""]);
// Exports
module.exports = exports;
